import { SearchService } from 'src/app/services/search.service';
import { Component, OnInit,Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'reviews-modal-body',
  templateUrl: './reviews-modal-body.component.html',
  styleUrls: ['./reviews-modal-body.component.css']
})
export class ReviewsModalBodyComponent {

    faTimesCircle=faTimesCircle;
    reviews;
    evaluationSummary;

    OnInit() {}

    constructor(
      private dialogRef: MatDialogRef<ReviewsModalBodyComponent>,
      @Inject(MAT_DIALOG_DATA) private data, service:SearchService) {
        this.evaluationSummary=data.vehicle.evaluationSummary;

      }

    close(): void {
        this.dialogRef.close();
    }

}
